import { render, staticRenderFns } from "./Shortlist.vue?vue&type=template&id=2bf9deae&scoped=true"
import script from "./Shortlist.vue?vue&type=script&lang=js"
export * from "./Shortlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf9deae",
  null
  
)

export default component.exports